import React, { useEffect, useState } from "react";
import { Header } from "../../components/Header/Header";
import Swal from "sweetalert2";
import { Navigator } from "../../components/Navigator/Navigator";
import { ContainerW } from "../../components/ContainerW";
import menuIcon from "../../assets/Notifications/menuIcon.svg";
import pointIcon from "../../assets/Notifications/point.svg";
import deleteIcon from "../../assets/Notifications/deleteIcon.svg";
import { EmailForm } from "../../components/EmailForm";
import { api } from "../../context/Auth";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";

function Notifications() {
  const { user } = useAuth();
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 50, totalPages: 1 });
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const itemsPerPage = 50;

  const handleEmailClick = (notification) => {
    setIsFormVisible(true);
  };

  const handleAction = async (action, notification) => {
    // console.log(action);
    
    setSelectedNotification(notification);
    Swal.fire({
      title: `¿Estás seguro de ${
        action === "approved" ? "aprobar" : "rechazar"
      } la solicitud ${notification.id}?`,
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      
      if (result.isConfirmed) {
        // console.log("XSADASDA");
        try {
          if (action === "rejected" && !commentText.trim()) {
            Swal.fire({
              icon: "warning",
              title: "Se requiere comentario",
              text: "Por favor, proporciona un comentario para rechazar la solicitud",
            });
            return;
          }
          // console.log("XSADASDA222");
          const response = await axios.post(
            `${api}/development/requestId/${notification.development_request_id}`,
            {
              action: action,
              comments: commentText,
              adminId: user.id,
            }
          );
          
          console.log(response);
          
          
          if (response.data.developments.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `Solicitud ${
                action === "approved" ? "aprobada" : "rechazada"
              } correctamente`,
            });
            setCommentText("");
            console.log("Notification:", notification);
            setNotifications((prevNotifications) =>
              prevNotifications.map((item) =>
                item.id === notification.id
            ? { 
              ...item, 
                      developmentRequest: {
                        ...item.developmentRequest, status: action
                      } 
                    }
                  : item
                )
              );
              
            // console.log(notification, selectedNotification);
            // if(notification.id === selectedNotification.id){
              setSelectedNotification({
                ...notification,
                developmentRequest: {
                  ...notification.developmentRequest, status: action
                }
              });
            // }
            // fetchNotifications(user.id); // Recargar notificaciones
          }
        } catch (error) {
          console.log(error);
          
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error.response?.data?.message || "Error al procesar la solicitud",
          });
        }
      }
    });
  };

  const fetchNotifications = async (id, page = 1) => {
    setLoadingNotifications(true);
    try {
      const response = await axios.get(
        `${api}/development/notifications/${id}?page=${page}&limit=${itemsPerPage}`
      );
      setNotifications(response.data.message.notifications);
      setPagination(response.data.message.pagination);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoadingNotifications(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchNotifications(user.id, currentPage);
    }
  }, [user, currentPage]);

  const markAsRead = async (id) => {
    try {
      await axios.patch(`${api}/development/markAsRead/${id}`);
    } catch (error) {
      console.error("Error marking as read:", error);
    }
  };
  const handleNotificationClick = (notification) => {
    setIsFormVisible(false);
    setSelectedNotification(notification);
    // Aquí podrías agregar una llamada a la API para marcar como leída
    markAsRead(notification.id);
    setNotifications((prevNotifications) =>
      prevNotifications.map((item) =>
        item.id === notification.id && item.status === "unread"
          ? { ...item, status: "read" }
          : item
      )
    );
    console.log("Notification:", notification);
    console.log("Selected Notification:", selectedNotification);
    
    
  };

  const handleDeleteNotification = async (notification) => {
    Swal.fire({
      title: "¿Estás seguro de eliminar la notificación?",
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await axios.get(api + "/user/deleteNotification/" + notification.id);

        if (response.data.success) {
          Swal.fire("Eliminado", "La notificación ha sido eliminada", "success");
          if (selectedNotification?.id === notification.id) {
            setSelectedNotification(null);
          }
          // Si era el último item de la página, retroceder una página
          if (notifications.length === 1 && currentPage > 1) {
            setCurrentPage(currentPage - 1);
          } else {
            fetchNotifications(user.id, currentPage);
          }
        }
        else{
          Swal.fire("Error", "No se pudo eliminar la notificación", "error");
        }
      }
    });
  }

  const getAction = (notification) => {
    if (notification.action_required) {
      return " requiere tu atención";
    }
    if (notification.message.includes("solicitud")) {
      return " ha enviado una solicitud";
    }
    return " ha realizado una acción";
  };

  return (
    <main className="w-[100svw] h-[100%] min-h-[100svh] max-w-[100svw] bg-[#eaeaea]">
      <Header />
      <div className="flex h-[100%] w-[calc(100svw - 20px)] pr-[20px] pb-[20px]">
        <Navigator />
        <div className="grid grid-cols-[320px_1fr] h-[100%] w-[100%] gap-[10px]">
          <div className="flex flex-col gap-[2px] h-[calc(100svh-120px)] overflow-y-auto rounded-lg shadow-md">
            <ContainerW>
              <div className="flex w-full justify-between pr-[8px] pl-[20px] py-[8px]">
                <h1 className="text-[24px] font-normal">Notificaciones</h1>
                <img src={menuIcon} alt="menuIcon" className="w-8 h-8" />
              </div>
            </ContainerW>
            {loadingNotifications && (
              <div className="flex justify-center items-center py-8">
                <span className="text-gray-500">Cargando notificaciones...</span>
              </div>
            )}
            {!loadingNotifications && notifications.map((notification) => (
              <ContainerW
                key={notification.id}
                onClick={() => handleNotificationClick(notification)}
                className={`cursor-pointer transition-all duration-200
          ${
            selectedNotification?.id === notification.id
              ? "bg-[#CCD4F778]"
              : ""
          }`}
              >
                <div className="flex flex-col h-auto w-full gap-2 py-3 px-4">
                  <div className="flex justify-between items-start">
                    {notification.status === "unread" && (
                      <img
                        src={pointIcon}
                        alt="Nuevo"
                        className="flex mt-[5px] w-3 h-3"
                      />
                    )}
                    <div className="flex flex-col">
                      <h5 className="text-[16px]">{notification.message}</h5>
                      <span className="text-sm -mt-[2px] text-gray-500">
                        {new Date(notification.createdAt).toLocaleString()}
                      </span>
                    </div>
                    <img
                      src={deleteIcon}
                      alt="Eliminar"
                      className="w-8 h-8 p-1.5 cursor-pointer rounded-lg hover:bg-nemu-platino"
                      onClick={() => handleDeleteNotification(notification)}
                    />
                  </div>
                  {notification.action_required && (
                    <div className="flex gap-2">
                      <button
                        onClick={() => {handleAction("approved", notification)}}
                        className={`py-[2px] px-3 text-white rounded-[4px] transition-all duration-300
                        ${
                          notification.developmentRequest?.status === "pending"
                            ? "bg-nemu-azul hover:bg-nemu-azulOscuro hover:scale-105 active:scale-95"
                            : "bg-gray-400 opacity-50 cursor-not-allowed"
                        }`}
                        disabled={
                          notification.developmentRequest?.status !== "pending"
                        }
                      >
                        <span>Aceptar</span>
                      </button>
                      <button
                        onClick={() => handleAction("rejected", notification)}
                        className={`py-[2px] px-3 rounded-[4px] transition-all duration-300
       ${
         notification.developmentRequest?.status === "pending"
           ? "text-nemu-black border-[1px] border-nemu-black hover:bg-nemu-platino hover:scale-105 active:scale-95"
           : "text-gray-500 border-[1px] border-gray-300 opacity-50 cursor-not-allowed"
       }`}
                        disabled={
                          notification.developmentRequest?.status !== "pending"
                        }
                      >
                        <span>Rechazar</span>
                      </button>
                    </div>
                  )}
                </div>
              </ContainerW>
            ))}
            {pagination.totalPages > 1 && (
              <div className="bg-white rounded-lg p-3 border border-gray-200 sticky bottom-0">
                <div className="flex items-center justify-between">
                  <button
                    onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                    disabled={currentPage === 1 || loadingNotifications}
                    className="px-3 py-1.5 bg-nemu-azul text-white text-sm rounded hover:bg-nemu-azulOscuro disabled:opacity-50 disabled:cursor-not-allowed transition"
                  >
                    Anterior
                  </button>
                  <div className="flex flex-col items-center">
                    <span className="text-sm text-gray-600">
                      Página {currentPage} de {pagination.totalPages}
                    </span>
                    <span className="text-xs text-gray-500">
                      {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, pagination.total)} de {pagination.total}
                    </span>
                  </div>
                  <button
                    onClick={() => setCurrentPage(p => Math.min(pagination.totalPages, p + 1))}
                    disabled={currentPage === pagination.totalPages || loadingNotifications}
                    className="px-3 py-1.5 bg-nemu-azul text-white text-sm rounded hover:bg-nemu-azulOscuro disabled:opacity-50 disabled:cursor-not-allowed transition"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md max-h-[calc(100svh-120px)] overflow-y-auto">
            {selectedNotification ? (
              <div className="flex flex-col">
                <div className="flex flex-col gap-2">
                  <div className="flex flex-col">
                    <div className="flex justify-between items-center">
                      <h2 className="text-2xl text-gray-800">
                        {selectedNotification.message}
                      </h2>
                      <div className="flex gap-[12px] justify-center items-center">
                        <img
                          onClick={() => handleEmailClick(selectedNotification)}
                          className="w-10 h-10 p-1.5 cursor-pointer rounded-full hover:bg-nemu-platino"
                          src="assets/Notifications/arrowNot.svg"
                          alt="Enviar correo"
                        />
                        <img
                          onClick={() => handleDeleteNotification(selectedNotification.id)}
                          className="w-10 h-10 p-1.5 cursor-pointer rounded-full hover:bg-nemu-platino"
                          src={deleteIcon}
                          alt="deleteIcon"
                        />
                      </div>
                    </div>
                    <p>({selectedNotification.development_request_id})</p>
                  </div>
                  <p className="text-[12px] text-gray-400">
                    {new Date(selectedNotification.createdAt).toLocaleString()}
                  </p>
                </div>
                <hr className="my-4" />

                {isFormVisible && (
                  <EmailForm onClose={() => setIsFormVisible(false)} />
                )}

                <div className="flex flex-col gap-[12px]">
                  <h2 className="text-base text-gray-800">
                    {selectedNotification.message}
                  </h2>
                  {selectedNotification.developmentRequest && (
                    <div className="bg-[#F5F5F5] p-4 rounded-lg">
                      {Object.entries(
                        JSON.parse(
                          selectedNotification.developmentRequest
                            .requested_changes
                        )
                      ).map(([key, value]) => (
                        <div key={key} className="flex items-start gap-2 mb-2">
                          <span className="font-medium capitalize">
                            {key.replace(/_/g, " ")}:
                          </span>
                          <span>{value.toString()}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-3 gap-4 mt-4">
                  {(selectedNotification.main_image !== null && selectedNotification.main_image !== "Sin imagen") && 
                    <div className="flex flex-col gap-2 items-center">
                      <img
                        className="rounded-lg w-full"
                        src={`${api}/${selectedNotification.main_image}`}
                        alt="imageUp"
                      />
                      <b>Imagen de portada</b>
                      <div className="flex justify-between items-end text-nemu-black">
                        <p className="text-base">
                          {selectedNotification.main_image.split("/").pop()}
                        </p>
                        <span className="text-xs">JPEG image - 153 KB</span>
                      </div>
                    </div>
                  }
                  {(selectedNotification.image !== null && selectedNotification.image !== "Sin imagen") && 
                    <div className="flex flex-col gap-2 items-center">
                      <img
                        className="rounded-lg w-full"
                        src={`${api}/${selectedNotification.image}`}
                        alt="imageUp"
                        />
                      <b>Imagen secundaria</b>
                      <div className="flex justify-between items-end text-nemu-black">
                        <p className="text-base">
                          {selectedNotification.image.split("/").pop()}
                        </p>
                        <span className="text-xs">JPEG image - 217 KB</span>
                      </div>
                    </div>
                  }
                  {(selectedNotification.enterprise_image !== null && selectedNotification.enterprise_image !== "Sin imagen") && 
                    <div className="flex flex-col gap-2 items-center">
                      <img
                        className="rounded-lg w-full"
                        src={`${api}/${selectedNotification.enterprise_image}`}
                        alt="imageUp"
                      />
                      <b>Imagen de la desarrolladora</b>
                      <div className="flex justify-between items-end text-nemu-black">
                        <p className="text-base">
                          {selectedNotification.enterprise_image.split("/").pop()}
                        </p>
                        <span className="text-xs">JPEG image - 153 KB</span>
                      </div>
                    </div>
                  }
                  {(selectedNotification.cover_page !== null && selectedNotification.cover_page !== "Sin imagen") && 
                    <div className="flex flex-col gap-2 items-center">
                      {selectedNotification.cover_page.split(",").map((cover, index) =>
                        <img
                          key={index}
                          className="rounded-lg w-full"
                          src={`${api}/${cover}`}
                          alt={`imageUp-${index}`}
                        />
                      )}
                      <b>Imagenes de amenidades</b>
                      <div className="flex justify-between items-end text-nemu-black">
                        <p className="text-base">
                          {selectedNotification.cover_page.split("/").pop()}
                        </p>
                        <span className="text-xs">JPEG image - 153 KB</span>
                      </div>
                    </div>
                  }
                </div>

                {selectedNotification.action_required && (
                  <>
                    <textarea
                      className={`w-full p-2 border rounded-md mt-4 transition-all duration-200
    ${
        selectedNotification.developmentRequest?.status !== "pending"
        ? "opacity-50 cursor-not-allowed bg-gray-50 resize-none border-gray-200"
        : "focus:border-nemu-azul focus:ring-1 focus:ring-nemu-azul focus:outline-none"
    }`}
                      placeholder="Agregar comentario (requerido para rechazar)"
                      value={commentText}
                      onChange={(e) => setCommentText(e.target.value)}
                      rows={3}
                      disabled={
                          selectedNotification.developmentRequest?.status !== "pending"
                      }
                    />
                    <div className="flex justify-end gap-2 mt-4">
                      <button
                        onClick={() =>
                          handleAction("rejected", selectedNotification)
                        }
                        className={`py-[4px] px-3 text-nemu-black border-[1px] border-nemu-black rounded-[4px] transition-all duration-300 
      ${
        selectedNotification.developmentRequest.status === "approved" || selectedNotification.developmentRequest.status === "rejected"
          ? "opacity-50 cursor-not-allowed bg-gray-100 hover:transform-none"
          : "hover:bg-nemu-platino hover:scale-105 active:scale-95"
      }`}
                        disabled={
                          selectedNotification.developmentRequest?.status !== "pending"
                        }
                      >
                        Rechazar
                      </button>
                      <button
                        onClick={() =>
                          handleAction("approved", selectedNotification)
                        }
                        className={`py-[4px] px-3 text-white bg-nemu-azul rounded-[4px] transition-all duration-300
      ${
          selectedNotification.developmentRequest?.status !== "pending"
          ? "opacity-50 cursor-not-allowed !bg-gray-400 hover:transform-none"
          : "hover:bg-nemu-azulOscuro hover:scale-105 active:scale-95"
      }`}
                        disabled={
                          selectedNotification.developmentRequest?.status !== "pending"
                        }
                      >
                        Aceptar
                      </button>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <p className="text-gray-500">
                Selecciona una notificación para ver los detalles.
              </p>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export { Notifications };
